import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import AcceptanceProduction from './modals/AcceptanceProduction';
import ShipmentDistributor from './modals/ShipmentDistributor';
import Movements from './modals/Movements';
import Pagination from 'components/Pagination';
import FilterSearch from 'components/FilterSearch';

import { GET, httpOk } from 'helpers/api';
import { DOWNLOAD_FILE, formatDate, formatMoney } from 'helpers/helpers';

import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';

function WarehouseFg() {
    const { t } = useTranslation()

    const [acceptanceProductionModal, setAcceptanceProductionModal] = useState(false)
    const [shipmentDistributorModal, setShipmentDistributorModal] = useState(false)
    const [movementsModal, setMovementsModal] = useState({ show: false, id: '' })

    const initFilterData = {
        page: 1,
        page_size: 20,
        search: '',
        status: '',
    }

    const [filterData, setFilterData] = useState(initFilterData)

    const [data, setData] = useState({})

    async function exportFile() {
        // Заменено на t('fg_warehouse')
        await DOWNLOAD_FILE('/inventory/fg-warehouse/items/export/', filterData, t('fg_warehouse'))
    }

    const handlePaginate = (args) => {
        setFilterData(prev => ({
            ...prev,
            page: args.page + 1,
            page_size: args.page_size
        }));
    };

    const getData = useCallback(async () => {
        const [response, responseStats] = await Promise.all([
            GET('/inventory/fg-warehouse/dashboard/', filterData),
            GET('/inventory/fg-warehouse/items/', filterData),
        ]);

        if (httpOk(response)) {
            setData({ ...response.data, ...responseStats.data });
        }
    }, [filterData]); 

    useEffect(() => {
        getData();
    }, [getData]);

    return (
        <>
            <div className="d-between">
                <div>
                    <div className="main-content-title">
                        {t('fg_warehouse')}
                    </div>

                    <div className="main-content-subtitle">
                        {t('stock_shipment_management_desc')}
                    </div>
                </div>

                {/* <div className="d-flex gap-8">
                    <button className="white gap-16" onClick={() => setAcceptanceProductionModal(true)}>
                        <PlusIcon />
                        {t('receipt_from_production')}
                    </button>

                    <button className="dark gap-16" onClick={() => setShipmentDistributorModal(true)}>
                        <TruckIcon />
                        {t('shipment')}
                    </button>
                </div> */}
            </div>

            <div className="grid4 gap-16">
                <div className="card">
                    <div className="d-between">
                        <div>
                            <div className="title">
                                {t('total_items')}
                            </div>
                            <div className="value">
                                {formatMoney(data?.summary?.total_items)}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="d-between">
                        <div>
                            <div className="title">
                                {t('total_balance')}
                            </div>
                            <div className="value primary">
                                {formatMoney(data?.summary?.total_quantity)} {data?.summary?.unit_short_name}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div>
                        <div className="title">
                            {t('reserved')}
                        </div>
                        <div className="value text-warning">
                            {formatMoney(data?.summary?.reserved_total)} {data?.summary?.unit_short_name}
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="d-between">
                        <div>
                            <div className="title">
                                {t('free_stock')}
                            </div>
                            <div className="value text-success">
                                {formatMoney(data?.summary?.available_total)} {data?.summary?.unit_short_name}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="d-flex gap-16 w-100">
                    <FilterSearch
                        value={filterData.search}
                        onChange={(e) => setFilterData({ ...filterData, search: e.target.value })}
                        placeholder={t('search_by_sku_or_name')}
                    />

                    <button className="white third" onClick={() => exportFile()}>
                        <DownloadIcon />
                        {t('export')}
                    </button>
                </div>
            </div>

            <div className="card">
                <div className="d-between mb-30">
                    <div className="fz16 text-third">
                        {t('finished_goods')}
                    </div>
                </div>

                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: '10%' }}>{t('sku')}</th>
                            <th style={{ width: '20%' }}>{t('name')}</th>
                            <th style={{ width: '10%' }}>{t('balance')}</th>
                            <th style={{ width: '10%' }}>{t('reserved')}</th>
                            <th style={{ width: '10%' }}>{t('available')}</th>
                            <th style={{ width: '10%' }}>{t('batch')}</th>
                            <th style={{ width: '10%' }}>{t('unit_short')}</th>
                            <th style={{ width: '10%' }}>{t('actions')}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data?.results?.map((item, index) => (
                            <tr key={index}>
                                <td>{item.product_code}</td>
                                <td>{item.product_name}</td>
                                <td>{formatMoney(item.quantity)} {item.unit_short_name}</td>
                                <td>{formatMoney(item.reserved_quantity)} {item.unit_short_name}</td>
                                <td>{formatMoney(item.available_quantity)} {item.unit_short_name}</td>
                                <td>{formatDate(item.last_updated)}</td>
                                <td>{item.unit_short_name}</td>
                                <td>
                                    <div className="d-flex align-items-center gap-8">
                                        <button className="transparent small" onClick={() => setMovementsModal({ show: true, id: item.product_id })}>
                                            {t('movements')}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>


                <Pagination
                    paginate={handlePaginate}
                    pagination={{
                        total: data?.count || 0
                    }}
                />

                <AcceptanceProduction modal={acceptanceProductionModal} setModal={setAcceptanceProductionModal} />
                <ShipmentDistributor modal={shipmentDistributorModal} setModal={setShipmentDistributorModal} />
                <Movements modal={movementsModal.show} setModal={() => setMovementsModal({ show: false })} id={movementsModal.id} />
            </div>
        </>
    )
}

export default WarehouseFg